import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@services/api'

export function useRepackers(search = '') {
  return useQuery({
    queryKey: ['repackers', search],
    queryFn: async () => {
      const res = await apiClient.get<any>('/repacking/repackers', {
        params: { search },
      })
      return res
    },
  })
}

export function useAvailableBulkBatches(productId?: number, search = '') {
  return useQuery({
    queryKey: ['available-bulk-batches', productId, search],
    queryFn: async () => {
      const res = await apiClient.get<any>('/repacking/bulk-batches', {
        params: { productId, search },
      })
      return res
    },
  })
}

export function useStartRepacking() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: {
      bulkBatchId: number
      inputQty: number
      repackerUserId: number
    }) => {
      const res = await apiClient.post<any>('/repacking', data)
      return res
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['repackings'] })
      queryClient.invalidateQueries({ queryKey: ['available-bulk-batches'] })
    },
  })
}

export function useRepackingDetail(id?: number) {
  return useQuery({
    queryKey: ['repacking-detail', id],
    queryFn: async () => {
      const res = await apiClient.get<any>(`/repacking/${id}`)
      return res
    },
    enabled: !!id,
  })
}

export function useRecordPackedGood() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: {
      repackingId: number
      packSizeId: number
      qtyPacked: number
    }) => {
      const res = await apiClient.post<any>(`/repacking/${data.repackingId}/packed-goods`, {
        packSizeId: data.packSizeId,
        qtyPacked: data.qtyPacked,
      })
      return res
    },
    onSuccess: (_, data) => {
      queryClient.invalidateQueries({
        queryKey: ['repacking-detail', data.repackingId],
      })
      queryClient.invalidateQueries({ queryKey: ['repackings'] })
    },
  })
}

export function useCompleteRepacking() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: number) => {
      const res = await apiClient.patch<any>(`/repacking/${id}/complete`)
      return res
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['repackings'] })
      queryClient.invalidateQueries({ queryKey: ['available-bulk-batches'] })
    },
  })
}

export function useRepackings(search = '', status = '') {
  return useQuery({
    queryKey: ['repackings', search, status],
    queryFn: async () => {
      const res = await apiClient.get<any>('/repacking', {
        params: { search, status },
      })
      return res
    },
  })
}
